import React, { FC, createElement } from 'react';

import { StyledH1, StyledH2, StyledH3, StyledH4, StyledH5, StyledH6 } from './styles';

export interface Props {
  level: 1 | 2 | 3 | 4 | 5 | 6;
  className?: string;
  bottom?: number;
  color?: string;
}

export const Heading: FC<Props> = ({ children, level, className, bottom, color }) => {
  const elements = {
    1: StyledH1,
    2: StyledH2,
    3: StyledH3,
    4: StyledH4,
    5: StyledH5,
    6: StyledH6,
  };

  return createElement(elements[level], { className, bottom, color }, children);
};
